import React from 'react'

export default props => (
  <svg width="22" height="27" viewBox="0 0 22 27" fill="#A1A7C0" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.125 4.54663L11.2188 9.09327V6.29999C11.1461 6.29776 11.0732 6.29663 11 6.29663C7.13401 6.29663 4 9.43064 4 13.2966C4 14.7046 4.41566 16.0154 5.13096 17.1132L2.51593 19.4842C1.24824 17.749 0.5 15.6102 0.5 13.2966C0.5 7.49764 5.20101 2.79663 11 2.79663C11.0731 2.79663 11.146 2.79738 11.2188 2.79887V0L17.125 4.54663ZM17.0854 9.83476C17.6675 10.8557 18 12.0373 18 13.2966C18 17.1626 14.866 20.2966 11 20.2966C10.9268 20.2966 10.8539 20.2955 10.7812 20.2933V17.5L4.875 22.0466L10.7812 26.5933V23.7944C10.854 23.7959 10.9269 23.7966 11 23.7966C16.799 23.7966 21.5 19.0956 21.5 13.2966C21.5 11.2386 20.9079 9.31878 19.8847 7.69835L17.0854 9.83476Z"
    />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Components/Icons/ArrowRefresh.js